import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    managingUnit,
    managingUnitTaxId,
    notificationReceivingAgency,
    releaseDate,
    representative,
    otherBillType,
  },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [otherBillType.name]: Yup.string().required(otherBillType.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [managingUnit.name]: Yup.string().required(managingUnit.errorMsg),
  [notificationReceivingAgency.name]: Yup.string().required(notificationReceivingAgency.errorMsg),
  [managingUnitTaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, managingUnitTaxId.invalidMsg)
    .required(managingUnitTaxId.errorMsg),
});

export default validation;
